module.exports = __webpack_public_path__ + "img/h3.32667821.png";